import { DoterSpecies, JoonColorExpanded } from "@joonapp/web-shared"

import ParentAvatar from "../../components/parentAvatar/ParentAvatar"

type Props = {
  avatar: DoterSpecies | null
  isSelected: boolean
  setSelectedParentAvatar: () => void
}

const ParentAvatarButton = ({
  avatar,
  isSelected,
  setSelectedParentAvatar,
}: Props) => {
  return (
    <button
      className={`w-full! h-full! border-3! overflow-hidden! rounded-xl! aspect-square ${isSelected ? "border-primary!" : "border-transparent!"}`}
      onClick={setSelectedParentAvatar}
    >
      <ParentAvatar
        avatar={avatar}
        style={{ width: "100%", height: "100%" }}
        backgroundColor={
          isSelected ? JoonColorExpanded.indigo200 : JoonColorExpanded.indigo100
        }
      />
    </button>
  )
}

export default ParentAvatarButton
